import { CaretDown } from '@phosphor-icons/react';
import { useState } from 'react';
import { DescripUnion } from '@Models/types';
import { getFields } from '@Utils/helpers';

// AccordionItem Component
interface AccordionItemProps<T> {
  item: T;
  isSelected: boolean;
  onSelect: (item: T, selected: boolean) => void;
  renderContent: (item: T) => React.ReactNode; // Function to render the content
}

const AccordionItem = <T extends DescripUnion>({
  item,
  isSelected,
  onSelect,
  renderContent,
}: AccordionItemProps<T>) => {
  const [isOpen, setIsOpen] = useState(false);

  //destructure item fields
  const { title, id } = getFields(item);

  return (
    <div role="region" className="border-b border-gray-300">
      {/* Header */}
      <div
        className="flex cursor-pointer flex-row items-center gap-x-2 bg-gray-100 p-4 hover:bg-gray-200"
        onClick={() => setIsOpen(!isOpen)}
      >
        <input
          data-testid={`test-accordion-checkbox-${title}`}
          type="checkbox"
          className="h-5 w-5"
          checked={isSelected}
          onChange={(e) => onSelect(item, e.target.checked)}
          onClick={(e) => e.stopPropagation()}
        />
        <div className="flex w-full flex-row items-center gap-x-2">
          <span className="text-xs font-bold text-gray-500">{id}</span>
          <span className="font-medium text-primary-600">{title}</span>
        </div>
        <CaretDown
          role="img"
          weight="bold"
          className={`transform hover:text-primary-500 ${isOpen ? 'rotate-180' : ''}`}
        />
      </div>

      {/* Content */}
      <div
        data-testid="test-accordion-content"
        className={`transition-max-height overflow-hidden ${
          !isOpen && 'max-h-0'
        }`}
      >
        <div className="p-4 text-xs sm:text-sm">{renderContent(item)}</div>
      </div>
    </div>
  );
};

export default AccordionItem;
